<template>
  <v-layout row wrap>
    <v-flex xs12 class='py-4 pl-4 yellow-shade' id='dashboardArea'>
      <v-tabs grow show-arrows class='dashboardTabs' v-if="this.$auth.check(['uber_admin','es_admin','coach'])" @change="handleUpdate">
        <v-tabs-slider class='tabSlider'></v-tabs-slider>

        <v-tab key="Groups" class='mr-4' @click="updateGroups()">My Groups</v-tab>
        <!-- <v-tab key="ESResource" class='mr-4' v-if="this.$auth.check(['uber_admin','es_admin','coach'])">Global Resources</v-tab> -->
        <v-tab key="Users" class='mr-4' v-if="this.$auth.check(['uber_admin','es_admin','coach'])">User Management</v-tab>
        <v-tab key="Org" class='mr-4' v-if="this.$auth.check(['uber_admin','es_admin','coach'])">Organization Management</v-tab>
        <v-tab key="Checkin" class='mr-4' v-if="this.$auth.check(['uber_admin','es_admin'])" href="/checkin" target="_blank">Event Checkin</v-tab>
         <v-tab key="NetCheckin" class='mr-4' v-if="this.$auth.check(['uber_admin','es_admin'])" href="/network/checkin" target="_blank">Network Membership</v-tab>
        <v-tab-item key="dashboard" class="pr-5">
          <DashboardMyGroups :groups="groups"></DashboardMyGroups>
          <DashboardMyModules :modules="modules"></DashboardMyModules>
        </v-tab-item>
        <!-- <v-tab-item key="ESResource">
          <DashboardESResources></DashboardESResources>
        </v-tab-item> -->
        <v-tab-item key="UserManagement" lazy>
          <DashboardUserManagement :key="tab"></DashboardUserManagement>
        </v-tab-item>
        <v-tab-item key="OrgManagement" lazy>
          <DashboardOrgManagement></DashboardOrgManagement>
        </v-tab-item>
      </v-tabs>
      <section v-else>
        <DashboardMyGroups :groups="groups"></DashboardMyGroups>
        <DashboardMyModules :modules="modules"></DashboardMyModules>
      </section>
    </v-flex>

  </v-layout>
</template>
<style lang="scss">
  @import "src/styles/variables.scss";
  #dashboardArea{
    min-height: 800px;
  }
  .dashboardTabs {
    .v-tabs__bar {
      border-bottom: 1px solid rgba(112, 112, 112, 0.2);
    }
    .tabSlider {
      background-color: #000000 !important;
      border-color: #000000 !important;
      height: 4px !important;
    }
    .v-tabs__item {
      font-family: $amaze-header-font-stack;
      font-size: 18px;
      line-height: 110%;
      font-weight: 700;
      text-transform: none;

      &.v-tabs__item--active{
        color: #000000 !important;
      }
    }
    .v-tabs__item:not(.v-tabs__item--active){
      opacity: 1 !important;
    }

    .v-tabs__bar {
      background-color: transparent !important;
      margin-bottom: 20px;
    }
  }
  .timeStampWrapper {
    color: $font-color-alt;
    font-family: $amaze-text-font-stack;
    small {
      font-size: 12px;
    }
  }
</style>

<script>
import AmazeNotifications from "@/components/Widgets/AmazeNotifications";
import DashboardMyGroups from "@/components/Widgets/Dashboard/MyGroups";
import DashboardMyModules from "@/components/Widgets/Dashboard/MyModules";
// import DashboardESResources from "@/components/Widgets/Dashboard/ESResources";
import DashboardUserManagement from "@/components/Widgets/Dashboard/UserManagement";
import DashboardOrgManagement from "@/components/Widgets/Dashboard/OrgManagement";

export default {
  components: {
    DashboardMyGroups,
    DashboardMyModules,
    DashboardUserManagement,
    DashboardOrgManagement
  },
  data: () => ({
    tab: false
  }),
  computed: {
    groups() {
      return this.$store.state.groups;
    },
    modules() {
      return this.$store.state.modules;
    }
  },
  methods: {
    handleUpdate: function() {
      this.tab = !this.tab;
    },
    updateGroups: function() {
      this.$store.commit('updateGroups');
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit("updateNotifications");
      vm.$store.commit("updateGroups");
      vm.$store.commit("loading", { loading: false });
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.commit("updateNotifications");
    this.$store.commit("loading", { loading: false });
    next();
  },
  mounted: function () {
    this.$nextTick(function () {
      this.$store.commit('updateGroups');
    })
  }
};
</script>
